import { useRef, useEffect } from "react";

const AttentionModal = ({ handleClose }) => {
  const modalRef = useRef(null);
  const ModalContainerRef = useRef(null);
  const handleClickOutside = (event) => {
    if (ModalContainerRef.current && !modalRef.current.contains(event.target)) {
      handleClose();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const handleDontShow = () => {
    localStorage.setItem("showModal", "false");
    handleClose();
  };

  return (
    <div className="modalContainer" ref={ModalContainerRef}>
      <div className="modal-deposit inner-modal" ref={modalRef}>
        <h2>Pay attention</h2>
        <button
          type="button"
          className="fancybox-button fancybox-close-small"
          onClick={() => handleClose()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewBox="0 0 24 24"
          >
            <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
          </svg>
        </button>
        <div className="modal-wrap">
          <div className="attention-top-text">
            <p>
              MATIC Capital is not a token, it is a new yield farm on Polygon
              that allows you to receive passive income for staking MATIC!
            </p>
          </div>
          <p className="attention-middle-text">
            Join our open Telegram chat, our support will answer you any
            questions! Thanks!
          </p>
          <div className="modal-btn-holder">
            <a
              href={process.env.REACT_APP_TELEGRAM_URL}
              target="_blank"
              className="modal-bottom-btn telegram-com-btn"
            >
              <img src="/assets/img/telegram.svg" alt="" /> &nbsp;Telegram
              Community
            </a>
            <button
              className="modal-bottom-btn dont-show-btn"
              onClick={handleDontShow}
            >
              Do not show again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttentionModal;
